<loading-pane [tracker]="tracker">
  <app-header [time]="time" [date]="dateWithoutYear"></app-header>

  <main>
    <router-outlet></router-outlet>
  </main>

  <app-footer id="footer" [time]="time" [date]="date"></app-footer>
</loading-pane>